import { BiPencil } from "react-icons/bi";
import { BsColumnsGap } from "react-icons/bs";
import {
  AiFillChrome,
  AiFillCompass,
  AiFillMobile,
  AiFillApi,
} from "react-icons/ai";
import {
  FaCloud,
  FaDatabase,
} from "react-icons/fa";

export const servicesData = [
  {
    id: 1,
    title: "UI/UX Design",
    icon: <BiPencil />,
  },
  {
    id: 2,
    title: "Web Development",
    icon: <AiFillCompass />,
  },
  {
    id: 3,
    title: "Mobile App Development",
    icon: <AiFillMobile />,
  },
  {
    id: 4,
    title: "Full Stack Development",
    icon: <BsColumnsGap />,
  },
  {
    id: 5,
    title: "API Development",
    icon: <AiFillApi />,
  },
  {
    id: 6,
    title: "Database Design & Optimization",
    icon: <FaDatabase />,
  },
  {
    id: 7,
    title: "Cloud Infrastructure",
    icon: <FaCloud />,
  },
  {
    id: 8,
    title: "Software Testing & QA",
    icon: <AiFillChrome />,
  },
];

